import axios from 'axios';
import { API_CONFIG, STORAGE_KEYS } from '../../constants';

const SERVER_URL = API_CONFIG.SERVER_URL;

const api = axios.create({
  baseURL: SERVER_URL,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(STORAGE_KEYS.TOKEN);
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem(STORAGE_KEYS.TOKEN);
      localStorage.removeItem(STORAGE_KEYS.USER);
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export interface EventAttributeData {
  name: string;
  isDeleted: boolean;
}

export interface EventAttribute {
  _id?: string;
  attributes?: Array<EventAttributeData>;
  eventId: string;
  workspaceId: string;
  createdAt?: string;
  updatedAt?: string;
}

export const getAttributes = async (
  eventName: string
): Promise<EventAttribute> => {
  try {
    const response = await api.get(`event-attributes/${eventName}`);
    const data = response.data?.data ?? response.data;
    return data;
  } catch (error) {
    console.error('Error fetching event attributes:', error);
    throw error;
  }
};
